import { getTSForGoalsOneOnOneTasks } from 'screens/home/summary/helpers';

import { endpoints } from 'constants/endpoints';

import { sendRequest } from 'api/sendRequest';

export function getMySummaryInitiativesTableDataApi({ resourceType, attributeFilter, pageType = 'HOME_PAGE' }) {
  const url = endpoints.analytics.initiative.list;

  const queryParams = {
    pageType,
    resourceType,
  };

  const body = {
    attributeFilter,
  };

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams,
    body,
  });
}
